import { useEffect, useRef, useState } from 'react';
import { RightFingerImage, LeftFingerImage } from "../utility/ImgNIcons";
import { ImageListItem } from '@mui/material';

const ImageDisplay = ({ fingerType, imageData, message, setFingerImage, fingerImage }: { fingerImage?: any, setFingerImage?: any, fingerType: any, imageData: any, message: any }) => {
    const fingerframe = useRef<HTMLCanvasElement | null>(null);
    const [imageUrl, setImageUrl] = useState()

    const drawFingerImage = (byteData: Uint8Array, canvas: any) => {
        const ctx = canvas.getContext('2d');
        const imgData = ctx.createImageData(canvas.width, canvas.height);

        for (let i = 0; i < byteData?.length; i++) {
            imgData.data[4 * i] = byteData[i];
            imgData.data[4 * i + 1] = byteData[i];
            imgData.data[4 * i + 2] = byteData[i];
            imgData.data[4 * i + 3] = 255;
        }
        ctx.putImageData(imgData, 0, 0, 0, 0, canvas.width, canvas.height);

        const image = ctx.canvas.toDataURL()
        setImageUrl(image)
        setFingerImage((prev: any) => { return { ...prev, fingerImage: image } })
    };

    useEffect(() => {
        if (imageData && fingerType) {
            drawFingerImage(imageData, fingerframe.current);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imageData]);

    useEffect(() => {
        const myCanvas = fingerframe.current;
        if (myCanvas) {
            const context = myCanvas.getContext('2d');
            if (context) {
                const img = new Image();
                img.onload = () => {
                    context.drawImage(img, 0, 0, myCanvas.width, myCanvas.height);
                };
                img.src = RightFingerImage;
            }
        }
    }, []);

    return (
        <>
            {fingerImage && !fingerType ?
                <img
                    style={{ width: '100%', objectFit: "contain", maxHeight: "240px", border: '2px solid green', borderRadius: '5px', filter: 'invert(1)' }}
                    src={fingerImage}
                    alt={'finger'}
                /> :
                <>
                    <ImageListItem>
                        <img style={{ width: '100%', objectFit: "contain", maxHeight: "240px", filter: 'invert(1)' }} src={imageUrl ? imageUrl : LeftFingerImage} alt="Profile" />
                    </ImageListItem>
                    <canvas hidden ref={fingerframe} height="480" width="320" style={{ border: '2px solid white', marginTop: '2rem' }}>
                    </canvas>
                </>
            }
            {fingerType && message ? <p>{message}</p> : null}
        </>
    );
};

export default ImageDisplay;